import React from 'react';

const CanceledDeliveriesStatus = ({ document }) => {
    const issues = document.issues || [];

    let classColor = (issues.length > 0) ? 'c-red' : '';

    const openIssues = e => {
        window.open('//issues.polisuite.com.br', '_blank');
    }

    return (
        <div title="Ver ocorrências" className={`label-icon ${classColor}`} onClick={openIssues} style={{cursor: 'pointer'}}>
            <i className="material-icons">warning</i>
            {issues.length}
        </div>
    );
}

CanceledDeliveriesStatus.defaultProps = {
    document: {}
};

export default CanceledDeliveriesStatus;



// WEBPACK FOOTER //
// ./src/components/Status/Issues.js